onReady((context) => {
  const runWhenIdle = (callback, timeout = 1500) => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(callback, { timeout });
      return;
    }
    setTimeout(callback, 300);
  };

  const $context = context && context.nodeType ? $(context) : $(document);
  const collectFoundationTargets = (selector) => {
    const $matches = $context.is(selector) ? $context : $();
    return $matches.add($context.find(selector));
  };
  const initFoundationPlugin = (selector) => {
    collectFoundationTargets(selector).each((i, el) => {
      const $el = $(el);
      if ($el.data("zfPlugin")) return;
      $el.foundation();
    });
  };

  initFoundationPlugin("[data-off-canvas]");
  initFoundationPlugin("[data-reveal]");
  initFoundationPlugin("[data-tabs]");
  initFoundationPlugin("[data-accordion]");
  $(".off-canvas").css("display", "");

  /* Sticky Header Function */
  const watchStickyHeader = () => {
    const sticky = $(".header__inner"),
      scroll = $(window).scrollTop();

    if (scroll >= 100) sticky.addClass("is-sticky");
    else sticky.removeClass("is-sticky");
  };
  watchStickyHeader();
  $(window).scroll(watchStickyHeader);

  //Initialize Header and Footer
  $("header.header").addClass("is-loaded");
  $("footer.footer").addClass("is-loaded");

  runWhenIdle(() => {
    // Quicklink
    if (window.quicklink && typeof quicklink.listen === "function") {
      quicklink.listen({
        ignores: [
          (uri) => {
            return (
              !uri.includes("/pages") &&
              !uri.includes("/blogs") &&
              !uri.includes("/products") &&
              !uri.includes("/collections")
            );
          },
        ],
      });
    }

    if ($(".header__currency-switcher").length) {
      new Promise((res) => {
        const interval = setInterval(() => {
          if ($(".pick_currency.mldesk").length) {
            clearInterval(interval);
            res();
          }
        }, 100);
      }).then(() => {
        $(".pick_currency.mldesk").appendTo($(".header__currency-switcher"));
      });
    }
  });

  runWhenIdle(() => {
    // Lozad
    $("img.lozad").each((i, e) => {
      const loadingAttr = (e.getAttribute("loading") || "").toLowerCase();
      const fetchpriorityAttr = (e.getAttribute("fetchpriority") || "").toLowerCase();
      if (loadingAttr === "eager" || fetchpriorityAttr === "high") {
        e.classList.remove("lozad");
        return;
      }
      $(e)
        .attr("data-src", $(e).attr("src"))
        .attr("data-srcset", $(e).attr("srcset"));
      $(e)
        .removeAttr("srcset")
        .removeAttr("loading")
        .attr("src", $(e).attr("src"));
    });

    if (typeof lozad === "function") {
      lozad("img.lozad").observe();
    }

    // Fade In Animation
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            $(entry.target).addClass("fade-in");
            currentObserver.unobserve(entry.target);
          }
        });
      });

      $('[data-inview="fade-in"]').each(function () {
        observer.observe(this);
      });
    } else {
      $('[data-inview="fade-in"]').addClass("fade-in");
    }
  });

  // Lock body scroll when off-canvas is open
  $(document).on("opened.zf.offCanvas", () => {
    $("body").addClass("body--no-scroll");
  });
  $(document).on("closed.zf.offCanvas", () => {
    $("body").removeClass("body--no-scroll");
  });
}, true);

// onReady(() => {
//   // Append view params to specific links
//   const viewParamRules = [
//     // { url: "/pages/process", template: "the-process" },
//     // { url: "/pages/athletes", template: "athletes" },
//     // { url: "/pages/faq", template: "faq" },
//     // {
//     //   url: "/pages/safety-isn-t-a-feature-it-s-a-system",
//     //   template: "safety-isn-t-a-feature-it-s-a-system",
//     // },
//     // {
//     //   url: "/pages/helmets-spring-2025",
//     //   template: "helmets",
//     // },
//     // {
//     //   url: "/pages/patent",
//     //   template: "patent",
//     // },
//     // {
//     //   url: "/products/rhoan-cstm",
//     //   template: "custom-product",
//     // },
//     // {
//     //   url: "/pages/warranty",
//     //   template: "warranty",
//     // },
//     // {
//     //   url: "/pages/about-us",
//     //   template: "about-us",
//     // },
//     // {
//     //   url: "/pages/privacy-policy",
//     //   template: "privacy-policy",
//     // },
//     // {
//     //   url: "/pages/helmet-technology",
//     //   template: "technology",
//     // },
//     // {
//     //   url: "/pages/press",
//     //   template: "media-kit",
//     // },
//     // {
//     //   url: "/products/kav-digital-gift-card",
//     //   template: "digital-card",
//     // },
//     // {
//     //   url: "/products/rhoan-hivis",
//     //   template: "hi-vis"
//     // },
//   ];

//   const applyViewParamsToLinks = () => {
//     const origin = window.location.origin;

//     $("a[href]").each((_, el) => {
//       const href = el.getAttribute("href");
//       if (
//         !href ||
//         href.startsWith("#") ||
//         href.startsWith("mailto:") ||
//         href.startsWith("tel:")
//       )
//         return;

//       const urlObj = new URL(href, origin);
//       const rule = viewParamRules.find((r) => urlObj.pathname === r.url);
//       if (!rule) return;

//       urlObj.searchParams.set("view", rule.template);
//       el.setAttribute("href", urlObj.pathname + urlObj.search + urlObj.hash);
//     });
//   };

//   applyViewParamsToLinks();
// });

onReady(() => {
  window.addEventListener("Angle3DAddToCart", function (event) {
    $("#offCanvasCart").foundation("open");
    window.CartJS.getCart();
  });
  $(document).on("open.zf.reveal", function () {
    document.documentElement.style.scrollBehavior = "auto";
    document.body.style.scrollBehavior = "auto";
    $("html, body").addClass("no-smooth-scroll");
  });

  $(document).on("closed.zf.reveal", function () {
    document.documentElement.style.scrollBehavior = "";
    document.body.style.scrollBehavior = "";
    $("html, body").removeClass("no-smooth-scroll");
  });
})
